(function () {
  if (window.RDCartUpsell) return;

  var autoKeys = {};
  var ERROR_KEY = 'rd-cart-upsell-error';
  var COLLAPSE_PREFIX = 'rd-cart-upsell-collapsed:';
  var activeCurrency = 'NZD';

  // Minimal UUID helper for offer-analytics operationIds — kept local since
  // this file has no module system to share it with rd-offer-events.js.
  function rdUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      try {
        return window.crypto.randomUUID();
      } catch (error) {
        // fall through to manual fallback
      }
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // Dispatches the offer-added signal that rd-offer-events.js listens for.
  // Best-effort only — analytics must never interfere with the cart flow.
  function dispatchOfferAdded(detail) {
    try {
      document.dispatchEvent(new CustomEvent('rd:offer-added', { detail: detail }));
    } catch (error) {
      // ignore — analytics is opt-in and non-critical
    }
  }

  function routesFallback(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status >= 400 || json.errors) {
          throw json;
        }
        return json;
      });
    });
  }

  function postJson(url, body) {
    return fetchJson(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
  }

  function getSectionsToRender(context) {
    var sections = context === 'page' ? ['cart-icon-bubble'] : ['cart-drawer', 'cart-icon-bubble'];
    // main-cart-items/main-cart-footer are JSON-template sections — their real
    // Section Rendering API id is the template-scoped value in data-id (e.g.
    // "template--123__cart-items"), not the literal element id.
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    if (itemsEl && itemsEl.dataset.id) sections.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) sections.push(footerEl.dataset.id);
    return sections;
  }

  function withRenderedSections(body, context) {
    return Object.assign({}, body, {
      sections: getSectionsToRender(context),
      sections_url: window.location.pathname
    });
  }

  function collapseKey(type, data, candidate) {
    var cartSignature = (data.cartItems || []).map(function (line) {
      return [line.key, line.quantity].join(':');
    }).sort().join('|');
    var bundle = candidate && candidate.bundle ? candidate.bundle.handle : '';
    var missing = candidate && candidate.missing ? candidate.missing.handle : '';
    return [type, bundle, missing, Number(data.cartTotal || 0), cartSignature].join(':');
  }

  function isCollapsed(type, data, candidate) {
    try {
      return sessionStorage.getItem(COLLAPSE_PREFIX + collapseKey(type, data, candidate)) === '1';
    } catch (error) {
      return false;
    }
  }

  function setCollapsed(key, collapsed) {
    if (!key) return;
    try {
      sessionStorage.setItem(COLLAPSE_PREFIX + key, collapsed ? '1' : '0');
    } catch (error) {
      // best-effort only — collapse state just won't persist across renders
    }
  }

  function toggleUpsellCollapse(root, toggleButton) {
    var card = toggleButton.closest('.rd-cart-upsell__card');
    if (!card) return;
    var nowCollapsed = !card.classList.contains('is-collapsed');
    card.classList.toggle('is-collapsed', nowCollapsed);
    toggleButton.setAttribute('aria-expanded', String(!nowCollapsed));
    toggleButton.setAttribute('aria-label', nowCollapsed ? 'Expand' : 'Collapse');
    setCollapsed(root._rdUpsellCollapseKey, nowCollapsed);
  }

  function isCompactDrawer(data) {
    return data && data.context === 'drawer' && data.drawerLayout === 'compact';
  }

  function stopCompactCarousel(root) {
    if (root._rdUpsellCarouselTimer) {
      clearInterval(root._rdUpsellCarouselTimer);
      root._rdUpsellCarouselTimer = null;
    }
  }

  function initCompactCarousel(root, type, data) {
    stopCompactCarousel(root);
    if (type !== 'shipping' || !isCompactDrawer(data)) return;

    var slider = root.querySelector('[data-rd-upsell-carousel]');
    var slides = slider ? Array.from(slider.querySelectorAll('[data-rd-upsell-product]')) : [];
    var prev = root.querySelector('[data-rd-upsell-carousel-prev]');
    var next = root.querySelector('[data-rd-upsell-carousel-next]');
    var dots = Array.from(root.querySelectorAll('[data-rd-upsell-carousel-dot]'));
    if (!slider || slides.length < 2) return;

    var index = 0;
    var pause = function () {
      stopCompactCarousel(root);
    };

    function updateDots() {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function goTo(nextIndex, shouldPause) {
      index = ((nextIndex % slides.length) + slides.length) % slides.length;
      slider.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      updateDots();
      if (shouldPause) pause();
    }

    var advance = function () {
      if (document.hidden) return;
      goTo(index + 1, false);
    };

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1, true);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1, true);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.dataset.rdUpsellCarouselDot || 0), true);
      });
    });
    updateDots();
    root._rdUpsellCarouselTimer = setInterval(advance, 4200);
    ['pointerdown', 'focusin', 'mouseenter'].forEach(function (eventName) {
      slider.addEventListener(eventName, pause, { once: true });
    });
  }

  function storePendingError(context, message) {
    try {
      sessionStorage.setItem(ERROR_KEY, JSON.stringify({
        context: context || '',
        message: message || 'Cart update failed. Your cart was refreshed.'
      }));
    } catch (error) {
      window.rdCartUpsellPendingError = {
        context: context || '',
        message: message || 'Cart update failed. Your cart was refreshed.'
      };
    }
  }

  function takePendingError(context) {
    var payload = null;

    try {
      payload = JSON.parse(sessionStorage.getItem(ERROR_KEY) || 'null');
      if (payload && (!payload.context || payload.context === context)) {
        sessionStorage.removeItem(ERROR_KEY);
      } else {
        payload = null;
      }
    } catch (error) {
      payload = null;
    }

    if (!payload && window.rdCartUpsellPendingError && (!window.rdCartUpsellPendingError.context || window.rdCartUpsellPendingError.context === context)) {
      payload = window.rdCartUpsellPendingError;
      window.rdCartUpsellPendingError = null;
    }

    return payload && payload.message ? payload.message : '';
  }

  function money(cents) {
    var value = Number(cents || 0) / 100;
    var hasCents = Math.round(Number(cents || 0)) % 100 !== 0;
    return '$' + value.toLocaleString('en-NZ', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    }) + ' ' + activeCurrency;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function variantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  function variantFirstOption(variant) {
    return variantOptions(variant)[0] || variant.title || 'Default Title';
  }

  function isDefaultOption(value) {
    return normalize(value) === 'default title';
  }

  function isAvailableVariant(variant) {
    return variant && variant.available !== false;
  }

  function availableVariants(product) {
    return (product.variants || []).filter(isAvailableVariant);
  }

  function firstAvailableVariant(product) {
    return availableVariants(product)[0] || (product.variants || [])[0] || null;
  }

  function productOptionIndex(product) {
    var options = product.options || [];
    var sizeIndex = options.findIndex(function (option) {
      return normalize(option).indexOf('size') !== -1;
    });
    return sizeIndex >= 0 ? sizeIndex : 0;
  }

  function productOptionValues(product) {
    var index = productOptionIndex(product);
    var seen = {};
    return availableVariants(product).reduce(function (values, variant) {
      var value = variantOptions(variant)[index] || variantFirstOption(variant);
      if (!value || isDefaultOption(value) || seen[normalize(value)]) return values;
      seen[normalize(value)] = true;
      values.push(value);
      return values;
    }, []);
  }

  function findVariantByValue(product, value) {
    var index = productOptionIndex(product);
    var normalizedValue = normalize(value);
    return availableVariants(product).find(function (variant) {
      return normalize(variantOptions(variant)[index] || variantFirstOption(variant)) === normalizedValue;
    }) || null;
  }

  function componentIsOneSize(component) {
    var variants = component.variants || [];
    var values;

    if (component.hasOnlyDefaultVariant) return true;
    if ((component.options || []).length) {
      var optionNames = (component.options || []).map(normalize);
      if (optionNames.every(function (option) { return option === 'title' || option === 'default title'; })) return true;
    }

    values = variants.map(variantFirstOption).filter(function (value) {
      return value && !isDefaultOption(value);
    });
    if (values.length === 0) return true;

    return values.every(function (value) {
      var normalizedValue = normalize(value);
      return normalizedValue === 'one size' || normalizedValue === 'onesize' || normalizedValue === 'os';
    });
  }

  function mapBundleOptionToComponent(optionName, components) {
    var option = normalize(optionName);
    var best = null;
    var bestScore = 0;

    components.forEach(function (component) {
      if (componentIsOneSize(component)) return;
      var words = normalize(component.title || component.handle).split(' ').filter(function (word) {
        return word.length > 1 && word !== 'the';
      });
      var score = words.reduce(function (total, word) {
        return total + (option.indexOf(word) !== -1 ? 1 : 0);
      }, 0);
      normalize(component.handle).split(' ').forEach(function (word) {
        if (word.length > 1 && option.indexOf(word) !== -1) score += 1;
      });
      if (score > bestScore) {
        best = component;
        bestScore = score;
      }
    });

    return best;
  }

  function getComponentValueFromLine(line) {
    var options = Array.isArray(line.variantOptions) ? line.variantOptions : [];
    return options.find(function (value) {
      return value && !isDefaultOption(value);
    }) || line.variantTitle || '';
  }

  function resolveBundleVariant(bundle, selections) {
    var optionNames = bundle.optionNames || [];
    var components = bundle.components || [];
    var optionComponents = optionNames.map(function (optionName) {
      return mapBundleOptionToComponent(optionName, components);
    });

    if (optionNames.length && optionComponents.some(function (component) { return !component; })) {
      return null;
    }
    var seenMappedComponents = {};
    for (var i = 0; i < optionComponents.length; i += 1) {
      var mappedComponent = optionComponents[i];
      if (!mappedComponent) continue;
      if (seenMappedComponents[mappedComponent.handle]) return null;
      seenMappedComponents[mappedComponent.handle] = true;
    }

    return (bundle.variants || []).find(function (variant) {
      if (!isAvailableVariant(variant)) return false;

      var options = variantOptions(variant);
      return optionComponents.every(function (component, index) {
        var selected = selections[component.handle];
        return selected && normalize(options[index]) === normalize(selected);
      });
    }) || null;
  }

  function analyzeBundles(data) {
    var cartLines = (data.cartItems || []).filter(function (line) {
      return !line.isBundleParent && !line.isBundleChild;
    });

    for (var b = 0; b < (data.bundles || []).length; b += 1) {
      var bundle = data.bundles[b];
      var components = (bundle.components || []).filter(Boolean);
      if (components.length < 2) continue;

      var selections = {};
      var selectedLines = [];
      var missing = [];
      var ambiguous = false;

      components.forEach(function (component) {
        var lines = cartLines.filter(function (line) {
          return line.productHandle === component.handle;
        });

        if (lines.length === 0) {
          missing.push(component);
          return;
        }

        if (lines.length > 1 || lines[0].hasSellingPlan || lines[0].hasProperties) {
          ambiguous = true;
          return;
        }

        selectedLines.push(lines[0]);
        selections[component.handle] = componentIsOneSize(component) ? 'One Size' : getComponentValueFromLine(lines[0]);
      });

      if (ambiguous) {
        return {
          type: 'ambiguous-full',
          bundle: bundle,
          components: components,
          message: 'Switch to bundle is paused because this cart has duplicate, quantity, custom, or selling-plan component lines.'
        };
      }

      if (missing.length === 0) {
        var fullVariant = resolveBundleVariant(bundle, selections);
        if (fullVariant) {
          return {
            type: 'full',
            bundle: bundle,
            components: components,
            lines: selectedLines,
            selections: selections,
            variant: fullVariant
          };
        }
      }

      if (missing.length === 1 && selectedLines.length === components.length - 1) {
        var mappedMissing = (bundle.optionNames || []).some(function (optionName) {
          return mapBundleOptionToComponent(optionName, components) && mapBundleOptionToComponent(optionName, components).handle === missing[0].handle;
        });
        if (!componentIsOneSize(missing[0]) && !mappedMissing) continue;

        return {
          type: 'partial',
          bundle: bundle,
          components: components,
          lines: selectedLines,
          selections: selections,
          missing: missing[0]
        };
      }
    }

    return null;
  }

  function renderBundlePrompt(root, data, candidate, collapsed) {
    var compact = isCompactDrawer(data);
    var compactClass = compact ? ' rd-cart-upsell__card--drawer-compact' : '';
    var title = candidate.type === 'partial' ? (compact ? 'Upgrade to Full Stack and Save' : 'Complete the Stack') : 'Switch to Bundle';
    var cta = candidate.type === 'partial' ? (compact ? 'Upgrade & Save \u2192' : 'Complete the Stack') : 'Switch to Bundle';
    var missingControls = '';
    var missingCard = '';

    if (candidate.type === 'ambiguous-full') {
      return '<div class="rd-cart-upsell__card rd-cart-upsell__card--notice">' +
        '<div class="rd-cart-upsell__head"><span>Complete the Stack</span></div>' +
        '<p class="rd-cart-upsell__copy">' + escapeHtml(candidate.message) + '</p>' +
        '</div>';
    }

    if (candidate.type === 'partial') {
      var missing = candidate.missing;
      var values = productOptionValues(missing);
      var selectedTotal = (candidate.lines || []).reduce(function (total, line) {
        var quantity = Math.max(1, Number(line.quantity || 1));
        var lineTotal = Number(line.finalLinePrice || line.originalLinePrice || 0);
        return total + (lineTotal / quantity);
      }, 0);
      var standalonePrice = Number(missing.price || 0);
      var upgradePrice = Number(candidate.bundle.price || 0) - selectedTotal;
      if (upgradePrice <= 0) upgradePrice = standalonePrice;
      var showWasPrice = upgradePrice < standalonePrice;
      missingCard = '<div class="rd-cart-upsell__missing-card">' +
        (missing.image ? '<img src="' + escapeHtml(missing.image) + '" alt="' + escapeHtml(missing.title) + '" loading="lazy">' : '') +
        '<div class="rd-cart-upsell__missing-info">' +
        '<small>Missing Piece</small>' +
        '<h3>' + escapeHtml(missing.title) + '</h3>' +
        '</div>' +
        '<div class="rd-cart-upsell__missing-price">' +
        (showWasPrice ? '<span class="rd-cart-upsell__missing-price--was">' + money(standalonePrice) + '</span>' : '') +
        '<span class="rd-cart-upsell__missing-price--plus">+' + money(upgradePrice) + '</span>' +
        '</div></div>';
      if (componentIsOneSize(missing)) {
        missingControls = '';
      } else {
        var selectedOnce = false;
        missingControls = '<div class="rd-cart-upsell__sizes' + (compact ? ' rd-cart-upsell__sizes--product' : '') + '" role="group" aria-label="' + escapeHtml(missing.title) + ' size">';
        values.forEach(function (value) {
          var testSelections = Object.assign({}, candidate.selections);
          var validVariant;
          testSelections[missing.handle] = value;
          validVariant = resolveBundleVariant(candidate.bundle, testSelections);
          var isSelected = !selectedOnce && validVariant;
          if (isSelected) selectedOnce = true;
          missingControls += '<button type="button" class="rd-cart-upsell__size' + (isSelected ? ' is-selected' : '') + '" data-rd-missing-size="' + escapeHtml(value) + '"' + (!validVariant ? ' disabled aria-disabled="true"' : '') + ' data-rd-offer-interaction="size_selection">' + escapeHtml(value) + '</button>';
        });
        missingControls += '</div>';
      }

      if (compact) {
        missingCard = '<div class="rd-cart-upsell__products rd-cart-upsell__products--bundle">' +
          '<div class="rd-cart-upsell__product rd-cart-upsell__product--bundle" data-rd-upsell-product="bundle">' +
          '<div class="rd-cart-upsell__product-top">' +
          (missing.image ? '<img src="' + escapeHtml(missing.image) + '" alt="' + escapeHtml(missing.title) + '" loading="lazy">' : '') +
          '<div class="rd-cart-upsell__product-info">' +
          '<span class="rd-cart-upsell__eyebrow">Missing Piece</span>' +
          '<a href="' + escapeHtml(missing.url || candidate.bundle.url || '#') + '">' + escapeHtml(missing.title) + '</a>' +
          '<small>' +
          (showWasPrice ? '<span class="rd-cart-upsell__price-was">' + money(standalonePrice) + '</span>' : '') +
          '<strong>+' + money(upgradePrice) + '</strong>' +
          (showWasPrice ? '<em>Save ' + money(standalonePrice - upgradePrice) + '</em>' : '') +
          '</small>' +
          '</div></div>' +
          '<button type="button" class="rd-cart-upsell__add rd-cart-upsell__add--upgrade" data-rd-convert-bundle data-rd-offer-interaction="primary_cta">' + cta + '</button>' +
          missingControls +
          '</div></div>';
        missingControls = '';
      }
    }

    root._rdUpsellCandidate = candidate;
    var bundleOfferId = 'cart-upsell-' + (candidate.bundle && candidate.bundle.handle ? candidate.bundle.handle : '');
    var bundleOfferAttrs = ' data-rd-offer="' + escapeHtml(bundleOfferId) + '" data-rd-offer-placement="cart_drawer" data-rd-offer-type="bundle"' +
      (candidate.bundle && candidate.bundle.handle ? ' data-rd-offer-product="' + escapeHtml(candidate.bundle.handle) + '"' : '');
    return '<div class="rd-cart-upsell__card rd-cart-upsell__card--bundle rd-cart-upsell__card--compact' + compactClass + (collapsed ? ' is-collapsed' : '') + '"' + bundleOfferAttrs + '>' +
      '<div class="rd-cart-upsell__head">' +
      '<span>' + title + '</span>' +
      '<button type="button" class="rd-cart-upsell__toggle" data-rd-toggle-upsell aria-expanded="' + (!collapsed) + '" aria-label="' + (collapsed ? 'Expand' : 'Collapse') + '">&#9662;</button>' +
      '</div>' +
      '<div class="rd-cart-upsell__body">' +
      (candidate.type === 'partial' ? missingCard + (missingControls ? '<div class="rd-cart-upsell__missing">' + missingControls + '</div>' : '') : '<p class="rd-cart-upsell__copy">Turn these pieces into ' + escapeHtml(candidate.bundle.title) + ' and use the real bundle price.</p>') +
      '<p class="rd-cart-upsell__error" data-rd-cart-upsell-error hidden></p>' +
      (compact && candidate.type === 'partial' ? '' : '<button type="button" class="rd-cart-upsell__button" data-rd-convert-bundle data-rd-offer-interaction="primary_cta">' + cta + '</button>') +
      '</div>' +
      '</div>';
  }

  function renderShippingUpsell(root, data, collapsed) {
    var freeShippingEligible = data.freeShippingEligible !== false;
    if (freeShippingEligible && Number(data.cartTotal || 0) >= Number(data.threshold || 0)) return '';

    var remaining = freeShippingEligible ? Number(data.threshold || 0) - Number(data.cartTotal || 0) : 0;
    var cartHandles = {};
    (data.cartItems || []).forEach(function (line) {
      cartHandles[line.productHandle] = true;
    });
    (data.bundles || []).forEach(function (bundle) {
      cartHandles[bundle.handle] = true;
    });

    var compact = isCompactDrawer(data);
    var products = (data.upsellProducts || [])
      .filter(function (product) {
        return product.available && !cartHandles[product.handle] && firstAvailableVariant(product);
      })
      .sort(function (a, b) {
        if (!freeShippingEligible) return Number(a.price || 0) - Number(b.price || 0);
        var aCrosses = Number(a.price || 0) >= remaining ? 0 : 1;
        var bCrosses = Number(b.price || 0) >= remaining ? 0 : 1;
        if (aCrosses !== bCrosses) return aCrosses - bCrosses;
        return Math.abs(Number(a.price || 0) - remaining) - Math.abs(Number(b.price || 0) - remaining);
      })
      .slice(0, compact ? 4 : 2);

    if (!products.length) return '';
    root._rdUpsellProducts = products;
    var compactControls = '';
    if (compact && products.length > 1) {
      compactControls = '<div class="rd-cart-upsell__carousel-controls" aria-label="Cart upsell products">' +
        '<button type="button" class="rd-cart-upsell__carousel-arrow rd-cart-upsell__carousel-arrow--prev" data-rd-upsell-carousel-prev aria-label="Previous upsell product">&#8249;</button>' +
        '<div class="rd-cart-upsell__carousel-dots">' +
        products.map(function (product, productIndex) {
          return '<button type="button" class="rd-cart-upsell__carousel-dot' + (productIndex === 0 ? ' is-active' : '') + '" data-rd-upsell-carousel-dot="' + productIndex + '" aria-label="Show ' + escapeHtml(product.title) + '"' + (productIndex === 0 ? ' aria-current="true"' : '') + '></button>';
        }).join('') +
        '</div>' +
        '<button type="button" class="rd-cart-upsell__carousel-arrow rd-cart-upsell__carousel-arrow--next" data-rd-upsell-carousel-next aria-label="Next upsell product">&#8250;</button>' +
        '</div>';
    }

    return '<div class="rd-cart-upsell__card rd-cart-upsell__card--shipping' + (compact ? ' rd-cart-upsell__card--drawer-compact' : '') + (collapsed ? ' is-collapsed' : '') + '">' +
      '<div class="rd-cart-upsell__head">' +
      '<span>' + (freeShippingEligible ? 'Add One to Ship Free' : 'Buy More Gear') + '</span>' +
      '<button type="button" class="rd-cart-upsell__toggle" data-rd-toggle-upsell aria-expanded="' + (!collapsed) + '" aria-label="' + (collapsed ? 'Expand' : 'Collapse') + '">&#9662;</button>' +
      '</div>' +
      '<div class="rd-cart-upsell__body">' +
      '<div class="rd-cart-upsell__products"' + (compact ? ' data-rd-upsell-carousel' : '') + '>' +
      products.map(function (product, productIndex) {
        var variant = firstAvailableVariant(product);
        var values = productOptionValues(product);
        var isSized = !componentIsOneSize(product) && values.length > 1;
        var sizeControls;
        if (isSized) {
          sizeControls = '<div class="rd-cart-upsell__sizes rd-cart-upsell__sizes--product" role="group" aria-label="' + escapeHtml(product.title) + ' size">' + values.map(function (value, valueIndex) {
            var valueVariant = findVariantByValue(product, value);
            return '<button type="button" class="rd-cart-upsell__size' + (valueIndex === 0 ? ' is-selected' : '') + '" data-rd-upsell-size data-variant-id="' + escapeHtml(valueVariant ? valueVariant.id : '') + '" data-rd-offer-interaction="size_selection">' + escapeHtml(value) + '</button>';
          }).join('') + '</div>';
        } else {
          // A static "one size" button fills the same row a real size picker would
          // occupy, so the Add buttons line up across one-size and sized products.
          var oneSizeLabel = variant ? variantFirstOption(variant) : '';
          if (!oneSizeLabel || isDefaultOption(oneSizeLabel)) oneSizeLabel = 'One Size';
          sizeControls = '<div class="rd-cart-upsell__sizes rd-cart-upsell__sizes--product">' +
            '<span class="rd-cart-upsell__size rd-cart-upsell__size--readonly">' + escapeHtml(oneSizeLabel) + '</span>' +
            '</div>';
        }
        var productOfferId = 'cart-upsell-' + (product.handle || '');
        return '<div class="rd-cart-upsell__product" data-rd-upsell-product="' + productIndex + '"' +
          ' data-rd-offer="' + escapeHtml(productOfferId) + '" data-rd-offer-placement="cart_drawer" data-rd-offer-type="product_upsell"' +
          (product.handle ? ' data-rd-offer-product="' + escapeHtml(product.handle) + '"' : '') + '>' +
          '<div class="rd-cart-upsell__product-top">' +
          (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
          '<div class="rd-cart-upsell__product-info">' +
          '<a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
          '<small>' + money(product.price) + '</small>' +
          '</div></div>' +
          sizeControls +
          '<button type="button" class="rd-cart-upsell__add" data-rd-add-upsell data-variant-id="' + escapeHtml(variant ? variant.id : '') + '" data-rd-offer-interaction="add_cta">Add</button>' +
          '</div>';
      }).join('') +
      '</div>' +
      compactControls +
      '<p class="rd-cart-upsell__error" data-rd-cart-upsell-error hidden></p>' +
      '</div>' +
      '</div>';
  }

  function render(root) {
    stopCompactCarousel(root);
    var script = root.querySelector('[data-rd-cart-upsell-data]');
    var mount = root.querySelector('[data-rd-cart-upsell-mount]');
    if (!script || !mount) return;

    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      mount.innerHTML = '';
      return;
    }

    root._rdUpsellData = data;
    activeCurrency = data.currency || activeCurrency;

    try {
      var candidate = analyzeBundles(data);
      // An "ambiguous-full" candidate means the bundle prompt is blocked, not
      // that one is actually available — don't let it crowd out an otherwise
      // unrelated free-shipping upsell.
      var isActionableBundle = !!candidate && candidate.type !== 'ambiguous-full';
      var type = isActionableBundle ? 'bundle' : 'shipping';
      root._rdUpsellCollapseKey = collapseKey(type, data, candidate);
      var collapsed = isCollapsed(type, data, candidate);
      var html = isActionableBundle ? renderBundlePrompt(root, data, candidate, collapsed) : renderShippingUpsell(root, data, collapsed);

      if (!html && candidate && candidate.type === 'ambiguous-full') {
        // No shipping upsell to fall back to either — show the paused notice
        // so the customer understands why nothing is happening, instead of
        // the upsell area silently going blank.
        type = 'bundle';
        root._rdUpsellCollapseKey = collapseKey(type, data, candidate);
        collapsed = isCollapsed(type, data, candidate);
        html = renderBundlePrompt(root, data, candidate, collapsed);
      }

      var pendingError = takePendingError(data.context);

      if (pendingError && !html) {
        html = '<div class="rd-cart-upsell__card rd-cart-upsell__card--notice">' +
          '<div class="rd-cart-upsell__head"><span>Cart Update</span></div>' +
          '<p class="rd-cart-upsell__error" data-rd-cart-upsell-error>' + escapeHtml(pendingError) + '</p>' +
          '</div>';
      }

      mount.innerHTML = html;
      root.hidden = !html;
      if (pendingError && html) showError(root, pendingError);
      initCompactCarousel(root, type, data);

      if (candidate && candidate.type === 'full' && data.mode === 'automatic') {
        var key = candidate.bundle.handle + ':' + candidate.lines.map(function (line) { return line.key; }).sort().join('|');
        if (!autoKeys[key] && !sessionStorage.getItem('rd-cart-upsell-auto:' + key)) {
          autoKeys[key] = true;
          sessionStorage.setItem('rd-cart-upsell-auto:' + key, '1');
          setTimeout(function () {
            convertBundle(root, candidate);
          }, 250);
        }
      }
    } catch (error) {
      if (window.console && console.error) console.error('rd-cart-upsell render failed', error);
      mount.innerHTML = '';
      root.hidden = true;
    }
  }

  function setBusy(root, busy) {
    root.classList.toggle('is-loading', busy);
    root.querySelectorAll('button, select').forEach(function (control) {
      control.disabled = busy;
    });
  }

  function showError(root, message) {
    var error = root.querySelector('[data-rd-cart-upsell-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function selectedMissingValue(root, candidate) {
    if (candidate.type !== 'partial') return null;
    if (componentIsOneSize(candidate.missing)) return 'One Size';
    var selected = root.querySelector('[data-rd-missing-size].is-selected');
    return selected ? selected.dataset.rdMissingSize : '';
  }

  function enrichPartialCandidate(root, candidate) {
    if (candidate.type !== 'partial') return candidate;
    var value = selectedMissingValue(root, candidate);
    if (!value) return null;
    var selections = Object.assign({}, candidate.selections);
    selections[candidate.missing.handle] = value;
    var variant = resolveBundleVariant(candidate.bundle, selections);
    if (!variant) return null;
    return Object.assign({}, candidate, { selections: selections, variant: variant });
  }

  function convertBundle(root, rawCandidate) {
    var candidate = enrichPartialCandidate(root, rawCandidate);
    if (!candidate || !candidate.variant) {
      showError(root, 'Choose a valid size to complete the stack.');
      return Promise.resolve();
    }

    setBusy(root, true);
    showError(root, '');

    var context = root._rdUpsellData && root._rdUpsellData.context;
    var operationId = rdUuid();
    var removeUpdates = {};
    candidate.lines.forEach(function (line) {
      // A component line with quantity > 1 only contributes one unit to the
      // bundle — decrement instead of removing, so the rest stays in the cart.
      removeUpdates[line.key] = Math.max(0, Number(line.quantity || 1) - 1);
    });

    // The offer surface is the rendered bundle card — read its data-rd-offer*
    // attributes so the add carries the same offer id/placement the card was
    // tagged with, falling back to the values used elsewhere in this file if
    // the card isn't found (e.g. in the automatic-conversion timing window).
    var surfaceEl = root.querySelector && root.querySelector('[data-rd-offer-type="bundle"]');
    var offerId = (surfaceEl && surfaceEl.getAttribute && surfaceEl.getAttribute('data-rd-offer')) ||
      ('cart-upsell-' + (candidate.bundle && candidate.bundle.handle ? candidate.bundle.handle : ''));
    var offerPlacement = (surfaceEl && surfaceEl.getAttribute && surfaceEl.getAttribute('data-rd-offer-placement')) || 'cart_drawer';
    var addBody = { id: candidate.variant.id, quantity: 1 };
    if (offerId && offerPlacement) {
      addBody.properties = {
        _rd_offer_id: offerId,
        _rd_offer_version: 'v1',
        _rd_offer_placement: offerPlacement
      };
    }

    return postJson(routesFallback('cart_add_url', '/cart/add.js'), addBody)
      .then(function () {
        return postJson(routesFallback('cart_update_url', '/cart/update.js'), withRenderedSections({
          updates: removeUpdates
        }, context));
      })
      .then(function (cartState) {
        dispatchOfferAdded({
          offerId: 'cart-upsell-' + (candidate.bundle && candidate.bundle.handle ? candidate.bundle.handle : ''),
          placement: 'cart_drawer',
          offerType: 'bundle',
          variantId: candidate.variant && candidate.variant.id,
          operationId: operationId,
          cartTotalCents: cartState && typeof cartState.total_price === 'number' ? cartState.total_price : undefined
        });
        return renderCartSections(cartState, context);
      })
      .catch(function () {
        var message = 'Could not switch these items to a bundle. Your cart was refreshed.';
        storePendingError(context, message);
        return refreshCart(context).catch(function () {
          showError(root, message);
        });
      })
      .finally(function () {
        setBusy(root, false);
      });
  }

  function addUpsell(root, button) {
    var productWrap = button.closest('[data-rd-upsell-product]');
    var selectedSize = productWrap && productWrap.querySelector('[data-rd-upsell-size].is-selected');
    var variantId = selectedSize ? selectedSize.dataset.variantId : button.dataset.variantId;

    if (!variantId) {
      showError(root, 'This item is no longer available.');
      return;
    }

    setBusy(root, true);
    showError(root, '');

    var context = root._rdUpsellData && root._rdUpsellData.context;
    var operationId = rdUuid();
    var offerId = productWrap && productWrap.dataset ? productWrap.dataset.rdOffer : '';
    var offerPlacement = productWrap && productWrap.dataset ? productWrap.dataset.rdOfferPlacement : '';

    var addBody = { id: Number(variantId), quantity: 1 };
    if (offerId && offerPlacement) {
      addBody.properties = {
        _rd_offer_id: offerId,
        _rd_offer_version: 'v1',
        _rd_offer_placement: offerPlacement
      };
    }

    postJson(routesFallback('cart_add_url', '/cart/add.js'), withRenderedSections(addBody, context))
      .then(function (cartState) {
        if (offerId) {
          dispatchOfferAdded({
            offerId: offerId,
            placement: 'cart_drawer',
            offerType: 'product_upsell',
            variantId: variantId,
            operationId: operationId,
            cartTotalCents: cartState && typeof cartState.total_price === 'number' ? cartState.total_price : undefined
          });
        }
        return renderCartSections(cartState, context);
      })
      .catch(function () {
        var message = 'Could not add this item. Your cart was refreshed.';
        storePendingError(context, message);
        return refreshCart(context).catch(function () {
          showError(root, message);
        });
      })
      .finally(function () {
        setBusy(root, false);
      });
  }

  function replaceSection(id, selector, html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var target = selector ? document.querySelector(selector) : document.getElementById(id);
    var source = selector ? parsed.querySelector(selector) : parsed.getElementById(id);
    if (!source) source = parsed.querySelector('.shopify-section');
    if (target && source) target.innerHTML = source.innerHTML;
  }

  function renderCartSections(payload, context) {
    if (!payload || !payload.sections) return refreshCart(context);

    var sectionHtml = payload.sections;
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var itemsSectionId = itemsEl && itemsEl.dataset.id;
    var footerSectionId = footerEl && footerEl.dataset.id;

    if (sectionHtml['cart-drawer']) replaceSection('CartDrawer', '#CartDrawer', sectionHtml['cart-drawer']);
    if (sectionHtml['cart-icon-bubble']) replaceSection('cart-icon-bubble', '#cart-icon-bubble', sectionHtml['cart-icon-bubble']);
    if (itemsSectionId && sectionHtml[itemsSectionId]) replaceSection('main-cart-items', '#main-cart-items .js-contents', sectionHtml[itemsSectionId]);
    if (footerSectionId && sectionHtml[footerSectionId]) replaceSection('main-cart-footer', '#main-cart-footer .js-contents', sectionHtml[footerSectionId]);

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof payload.item_count === 'number') drawer.classList.toggle('is-empty', payload.item_count === 0);
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') {
        overlay.addEventListener('click', drawer.close.bind(drawer));
      }
      if (context === 'drawer' && typeof drawer.open === 'function') drawer.open();
    }
    var footer = document.getElementById('main-cart-footer');
    if (footer && typeof payload.item_count === 'number') footer.classList.toggle('is-empty', payload.item_count === 0);

    if (window.publish && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'rd-cart-upsell', cartData: payload });
    }

    window.RDCartUpsell.init();
    return payload;
  }

  function refreshCart(context) {
    var cartUrl = routesFallback('cart_url', '/cart');
    var sections = getSectionsToRender(context);

    return Promise.all([
      fetchJson(routesFallback('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } }),
      fetchJson(cartUrl + '?sections=' + sections.join(',') + '&sections_url=' + encodeURIComponent(window.location.pathname), {
        headers: { Accept: 'application/json' }
      })
    ]).then(function (results) {
      var cart = results[0];
      cart.sections = results[1];
      return renderCartSections(cart, context);
    });
  }

  function bind(root) {
    if (root._rdUpsellBound) return;
    root._rdUpsellBound = true;

    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-rd-toggle-upsell]');
      if (toggle) {
        event.preventDefault();
        toggleUpsellCollapse(root, toggle);
        return;
      }

      var sizeButton = event.target.closest('[data-rd-missing-size]');
      if (sizeButton) {
        event.preventDefault();
        root.querySelectorAll('[data-rd-missing-size]').forEach(function (button) {
          button.classList.toggle('is-selected', button === sizeButton);
        });
        return;
      }

      var upsellSize = event.target.closest('[data-rd-upsell-size]');
      if (upsellSize) {
        event.preventDefault();
        var productWrap = upsellSize.closest('[data-rd-upsell-product]');
        if (productWrap) {
          productWrap.querySelectorAll('[data-rd-upsell-size]').forEach(function (button) {
            button.classList.toggle('is-selected', button === upsellSize);
          });
          var addButton = productWrap.querySelector('[data-rd-add-upsell]');
          if (addButton) addButton.dataset.variantId = upsellSize.dataset.variantId || '';
        }
        return;
      }

      var convert = event.target.closest('[data-rd-convert-bundle]');
      if (convert) {
        event.preventDefault();
        convertBundle(root, root._rdUpsellCandidate);
        return;
      }

      var add = event.target.closest('[data-rd-add-upsell]');
      if (add) {
        event.preventDefault();
        addUpsell(root, add);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-rd-cart-upsell]').forEach(function (root) {
      bind(root);
      render(root);
    });
  }

  window.RDCartUpsell = {
    init: init,
    refreshCart: refreshCart
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches('[data-rd-cart-upsell]') || node.querySelector && node.querySelector('[data-rd-cart-upsell]'));
      });
    })) {
      init();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
